import { render, staticRenderFns } from "./FieldTimeformat.vue?vue&type=template&id=37d70e8d&"
import script from "./FieldTimeformat.vue?vue&type=script&lang=js&"
export * from "./FieldTimeformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports